import { makeStyles } from "@mui/styles";
import { COLORS } from "../../../constant/colors";

export default makeStyles(() => ({
  aboutSec: {
    padding: "80px 0",
    background: `linear-gradient(135deg, ${COLORS.creamLight} 0%, ${COLORS.white} 100%)`,
    marginBottom: 70,
    "@media (max-width: 600px)": {
      padding: "20px 0",
      marginBottom: 20,
    },
  },
  imgSec: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    "& img": {
      width: "100%",
      borderRadius: 20,
      boxShadow: "0 16px 32px rgba(0, 0, 0, 0.1)",
      transition: "transform 0.3s ease",
      "&:hover": {
        transform: "scale(1.02)",
      },
    },
  },
  row: {
    alignItems: "center",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "@media (max-width: 767px)": {
      marginBottom: 30,
      textAlign: "center",
      marginTop: 20,
      paddingLeft: "3%",
    },
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: 700,
    color: COLORS.textPrimary,
    marginBottom: 24,
    fontFamily: "'Poppins', sans-serif",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: -8,
      left: 0,
      width: 60,
      height: 4,
      background: `linear-gradient(90deg, ${COLORS.primary} 0%, ${COLORS.secondary} 100%)`,
      borderRadius: 2,
    },
    "@media (max-width: 768px)": {
      "&::after": {
        left: "50%",
        transform: "translateX(-50%)",
      },
    },
    "@media (max-width: 600px)": {
      fontSize: "1.8rem",
      marginBottom: 20,
    },
  },
  paraDiv: {
    marginBottom: 20,
    "& p": {
      fontSize: "1.1rem",
      lineHeight: 1.7,
      color: COLORS.textSecondary,
      fontFamily: "'Poppins', sans-serif",
      "@media (max-width: 600px)": {
        fontSize: "0.95rem",
      },
    },
    "@media (max-width: 767px)": {
      marginBottom: 16,
    },
  },
  btnSec: {
    maxWidth: 280,
    width: "100%",
    "@media (max-width: 768px)": {
      margin: "0 auto",
    },
    "@media (max-width: 600px)": {
    },
  },
}));
